module.exports = __webpack_public_path__ + "static/img/13.5824598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/13.jpg
// module id = BdhQ
// module chunks = 1